module.exports = __webpack_public_path__ + "assets/pivot_logo-44729d32-pivot.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styl/images/pivot_logo.svg
// module id = 531
// module chunks = 47